import { Stack, Typography } from "@mui/material"
import { SmallErrorIcon, SmallWarningIcon } from "@tc/ui-dfe/icons"

interface FormErrorPromptProps {
  message?: string
  variant?: "error" | "warning"
}

export const FormErrorPrompt = ({
  message,
  variant = "error",
}: FormErrorPromptProps) => {
  if (!message) {
    return null
  }

  const isWarning = variant === "warning"

  return (
    <Stack component="span" direction="row" alignItems="center" gap={0.5}>
      {isWarning ? (
        <SmallWarningIcon
          sx={{
            width: 18,
            fill: (theme) => theme.palette.warning.main,
          }}
        />
      ) : (
        <SmallErrorIcon
          sx={{
            width: 18,
            fill: (theme) => theme.palette.error.main,
          }}
        />
      )}
      <Typography
        variant="body2"
        component="span"
        color={isWarning ? "text.primary" : "error"}
      >
        {message || " "}
      </Typography>
    </Stack>
  )
}
